import React from "react";
// import CV from "../../assets/cv_meri_gogichashvili.pdf";

const CTA = () => {
  return (
    <div className="cta">
      <a href={"https://drive.google.com/file/d/1WhqbSD6Hlc9j4naFcIeoBsAu2PkmzRl8/view?usp=drive_link"} download className="btn">
        Download CV
      </a>

      <a href="#contact" className="btn btn-primary">
        Let's talk
      </a>
    </div>
  );
};

export default CTA;
